module.exports = __webpack_public_path__ + "img/health-coach-logo.a920faf6.png";